
const getRandomInt = () => {
    return parseInt(Math.random() * 100);
  };
export default getRandomInt  